module.exports = __webpack_public_path__ + "img/DSC_0043_inPixio.07beee7a.jpg";